"use strict";

function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.left,
    t = e.right,
    p = e.up,
    a = e.down,
    l = e.top,
    u = e.bottom,
    i = e.mirror,
    n = e.opposite,
    s = (r ? 1 : 0) | (t ? 2 : 0) | (l || a ? 4 : 0) | (u || p ? 8 : 0) | (i ? 16 : 0) | (n ? 32 : 0) | (o ? 64 : 0);
  if (lookup.hasOwnProperty(s)) return lookup[s];
  if (!i != !(o && n)) {
    var d = [t, r, u, l, a, p];
    r = d[0], t = d[1], l = d[2], u = d[3], p = d[4], a = d[5];
  }
  var f = "-200deg",
    _ = "center";
  return (a || l) && r && (f = "-45deg"), ((a || l) && t || (p || u) && r) && (f = "45deg"), (p || u) && t && (f = "-90deg"), (r || t) && (_ = (r ? "left" : "right") + " bottom"), lookup[s] = (0, _globals.animation)("\n    " + (o ? "to" : "from") + " { opacity: 0; transform-origin: " + _ + "; transform: rotate3d(0, 0, 1, " + f + ");}\n    " + (o ? "from" : "to") + " { opacity: 1; transform-origin: " + _ + "; transform: none;}\n  "), lookup[s];
}
function Rotate() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = o.children,
    r = (o.out, o.forever),
    t = o.timeout,
    p = o.duration,
    a = void 0 === p ? _globals.defaults.duration : p,
    l = o.delay,
    u = void 0 === l ? _globals.defaults.delay : l,
    i = o.count,
    n = void 0 === i ? _globals.defaults.count : i,
    s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    d = {
      make: make,
      duration: void 0 === t ? a : t,
      delay: u,
      forever: r,
      count: n,
      style: {
        animationFillMode: "both"
      }
    };
  return (0, _wrap2.default)(s, d, d, e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _propTypes = require("prop-types"),
  _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
Rotate.propTypes = propTypes, exports.default = Rotate, module.exports = exports.default;